export const urlBackendUsuarios = import.meta.env.VITE_URL_BACK_USUARIOS;
export const urlBackendParametros = import.meta.env.VITE_URL_BACK_PARAMETROS;
export const urlBackendPDFBuilder = import.meta.env.VITE_URL_BACK_PDFBUILDER;
export const admBack = import.meta.env.VITE_ADM_BACK;
export const microAuthBack = import.meta.env.VITE_MICRO_AUTH;
export const personasBack = import.meta.env.VITE_PERSONAS_BACK;

